<div>
    <div class="overlay" *ngIf="helperService.preloader">
      <div class="overlay__inner">
          <div class="overlay__content"><div class="loader"></div></div>
      </div>
    </div>
</div>